<template>
  <div style="display: flex; justify-content: space-between; background-color: rgb(249, 249, 249)">
    <div style="display: flex; align-items: center;">
      <button style="margin-left: 5px;" @click="clickLogoutBtn">
        <v-icon color="gray">mdi-backburger</v-icon>
      </button>
    </div>
    <div style="display: flex; align-items: center;">
      <button style="display: flex; font-size: 13px; align-items: center; padding-right: 15px;" @click="subscriptions">
        <v-icon color="gray darken-2" small>mdi-currency-usd</v-icon>
        {{ $i18n.t("ppt_add_in_main.subscription_settings") }}
      </button>
      <button style="display: flex; font-size: 13px; align-items: center; padding-right: 15px;" @click="settings">
        <v-icon color="gray darken-2" small>mdi-cog</v-icon>
        {{ $i18n.t("ppt_add_in_main.user_settings") }}
      </button>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" style="font-size: 13px; margin-right: 20px;">
            <v-icon color="gray darken-2" small>mdi-format-list-bulleted</v-icon>
            {{ $i18n.t("home.action_header_menu") }}
          </button>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index">
            <v-chip v-if="index == 0" color="primary" dark outlined label @click="createWholeSlides()"
              style="height: 30px; width: 95%; font-size: 13.5px;">
              <v-icon left size="22"> mdi-microsoft-powerpoint </v-icon>
              {{ item.title }}
            </v-chip>
            <v-chip v-if="index == 1" color="primary" dark outlined label @click="showSlideOutline()"
              style="height: 30px; width: 95%; font-size: 13.5px; color: black;">
              <v-icon left size="22"> mdi-format-line-weight </v-icon>
              {{ item.title }}
            </v-chip>
            <v-chip v-if="index == 2" color="primary" dark outlined label @click="createOnePageSlides()"
              style="height: 30px; width: 95%; font-size: 13.5px; color: black;">
              <v-icon left size="22"> mdi-file-powerpoint-outline </v-icon>
              {{ item.title }}
            </v-chip>
            <v-chip v-if="index == 3" color="primary" dark outlined label @click="createPPTfromFile()"
              style="height: 30px; width: 95%; font-size: 13.5px; color: black;">
              <v-icon left size="22"> mdi-file-document-plus-outline </v-icon>
              {{ item.title }}
            </v-chip>
            <v-chip v-if="index == 4" color="primary" dark outlined label @click="createWholeTemplateSlides()"
              style="height: 30px; width: 95%; font-size: 13.5px;">
              <v-icon left size="22"> mdi-air-filter </v-icon>
              {{ item.title }}
            </v-chip>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <!-- 设置图片风格 -->
    <v-dialog v-model="dialog" persistent>
      <div class="imageDialogCard" style="width: 100%;">
        <div class="imag-select-header-area">
          {{ $i18n.t("ppt_add_in_main.img_style_select_title") }}
          <button v-if="showSaveBtn" @click="saveSettings()" style="margin-left: 50px; color: rgb(43,87,154);">
            {{ $i18n.t("ppt_add_in_main.save") }}
            <v-icon color="primary">mdi-check</v-icon>
          </button>
          <button @click="clickCloseSettings()">
            <v-icon>mdi-close</v-icon>
          </button>
        </div>
        <!-- 图片风格选择区域 -->
        <div class="style-header">
          <div style="display: flex; justify-content: space-between;">
            <div class="subtitle-text">
              {{ $i18n.t("ppt_add_in_main.subtitle_mode") }}
            </div>
          </div>
          <div class="mode-select-options" style="margin-bottom: 10px;">
            <div class="mode-select-option" :class="{ 'active': selectedMode === ImageMode.BUSINESS }"
              style="margin-bottom: 5px;" @click="selectBussiness()">
              <div style="display: flex;">
                <h5>{{ $i18n.t("ppt_add_in_main.business_style") }}</h5>
                <p> - </p>
                <p>{{ $i18n.t("ppt_add_in_main.business_style_desc") }}</p>
              </div>
              <div class="img-container-mode">
                <img :src=businessImgPath alt="" />
              </div>
            </div>

            <div class="mode-select-option" :class="{ 'active': selectedMode === ImageMode.FREE }"
              @click="selectFree()">
              <div style="display: flex;">
                <h5>{{ $i18n.t("ppt_add_in_main.free_style") }}</h5>
                <p> - </p>
                <p>{{ $i18n.t("ppt_add_in_main.free_style_desc") }}</p>
              </div>
              <div class="img-container-mode">
                <img :src=freeImgPath alt="" />
              </div>
            </div>
          </div>
          <div v-if="false" style="display: flex; align-items: center; padding: 0 5px; margin-top: 12px;">
            <div style="font-size: 13px; margin-left: 5px; "> {{ '切换系统默认模板：' }} </div>
            <SwitchCompoent @change="handleSwitchChange"></SwitchCompoent>
            <div style="font-size: 13px; margin-left: 5px; "> {{ '企业模板样例' }} </div>
          </div>

          <!-- 艺术流派概览按钮 -->
          <div>
            <div>
              <div class="subtitle-text">
                {{ $i18n.t("ppt_add_in_main.subtitle_style") }}
              </div>
            </div>
            <div class="mode-select-options">
              <div class="mode-select-option" :class="{ 'active': selecteStyledMode === ImageStyleMode.AI }"
                style="margin-bottom: 5px;" @click="selectImageStyleAIMode()">
                <div style="display: flex;">
                  <div style="font-size: 12px;">{{ $i18n.t("ppt_add_in_main.style_mode_ai") }}</div>
                </div>
              </div>

              <div class="mode-select-option" :class="{ 'active': selecteStyledMode === ImageStyleMode.HUMAN }"
                @click="selectImageStyleHumanMode()">
                <div style="display: flex;">
                  <div style="font-size: 12px;">{{ $i18n.t("ppt_add_in_main.style_mode_human") }}</div>
                </div>
              </div>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; margin-top: -18px; ">
            <div class="selected-img-style">
              {{ selecteStyledMode === ImageStyleMode.HUMAN ? $i18n.t("ppt_add_in_main.img_style_selected_title") : '' }}
              <div style="color: rgb(24, 103, 192); font-size: 12px;">
                {{ selecteStyledMode === ImageStyleMode.HUMAN ? selectedImageStyleName : $i18n.t("ppt_add_in_main.img_style_selected_AI") }}
              </div>
            </div>
            <div class="art-title-style" @click="previewArtList()">
              {{ $i18n.t("ppt_add_in_main.art_style_overview") }}
              <v-icon>{{ isArtListVisible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </div>
          </div>
        </div>
        <v-list class="scroll-area" v-if="isArtListVisible" dense :style="{ maxHeight: listMaxHeight + 'px' }"
          style="margin-top: -10px;">
          <!-- 非 AI 风格模式：使用选中效果 -->
          <v-list-item-group v-if="selecteStyledMode != ImageStyleMode.AI" v-model="selectedItem" color="primary">
            <v-row dense>
              <v-col v-for="(item, i) in getImageStyle()" :key="i" cols="6"
                style="display: flex; justify-content: center;">
                <v-list-item class="custom-list-item"
                  style="flex-direction: column; align-items: center; text-align: center;">
                  <div class="img-container">
                    <img :src="item.imgPath" alt="" />
                  </div>
                  <div style="font-size: 12px;">{{ item.text }}</div>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>

          <!-- AI搭配风格时，无选中效果 -->
          <div v-else>
            <v-row dense>
              <v-col v-for="(item, i) in getImageStyle()" :key="i" cols="6">
                <v-list-item class="custom-list-item"
                  style="flex-direction: column; align-items: center; text-align: center;">
                  <div class="img-container">
                    <img :src="item.imgPath" alt="" />
                  </div>
                  <div style="font-size: 12px;">{{ item.text }}</div>
                </v-list-item>
              </v-col>
            </v-row>
          </div>
        </v-list>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
// import { get, sync } from "vuex-pathify";
import { i18n } from "@/plugins/i18n.js";
import { actionMenuPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
// import { getServiceWindowAvatar } from "@/service/wd_service_com.js";
import { resetAllModulesState } from "@/store/modules/index.js"
import aiMenusZh from "@/store/modules/aiMenus-zh";
import aiMenusEn from "@/store/modules/aiMenus-en";
import { ImageGenerateMode, ImageStyleMode } from "@/store/modules/enums.js";
//例如: import <组件名称> from  <组建路径>
import SwitchCompoent from "../dialog/switchComponent.vue";
export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    SwitchCompoent
  },
  props: {},
  data() {
    //这里存放数据
    return {
      ImageStyle: [],
      imageStyles: [],
      showSwireCokeBtn: false, // 是否显示太古可乐按钮
      clickLogOutBtnTime: null,
      items: [
        { title: i18n.t("welcomeMessageCard.action_create_whole_slides") },
        { title: i18n.t("welcomeMessageCard.action_create_slide_outline") },
        { title: i18n.t("welcomeMessageCard.action_create_one_page_slide") },
        { title: i18n.t("welcomeMessageCard.action_create_ppt_from_file") },
        { title: i18n.t("welcomeMessageCard.action_create_whole_template_slides") },
      ],
      dialog: false,
      selectedItem: localStorage.getItem(userKeys.key_user_settings_image_style_index),
      showSaveBtn: this.selectedMode === localStorage.getItem(userKeys.key_user_settings_image_mode),
      isModeVisible: true,
      isArtListVisible: false,
      selectedMode: localStorage.getItem(userKeys.key_user_settings_image_mode) || ImageGenerateMode.BUSINESS,
      ImageMode: ImageGenerateMode, // 将枚举暴露到模板
      selecteStyledMode: localStorage.getItem(userKeys.key_user_settings_image_style_mode) || ImageStyleMode.AI,
      ImageStyleMode: ImageStyleMode,
      selectedImageStyleName: localStorage.getItem(userKeys.key_user_settings_image_style) || "",
      freeImgPath: require("@/views/chatdoc/img/free.png"),
      businessImgPath: require("@/views/chatdoc/img/business.png"),
    };
  },
  //计算机属性 类似与data概念
  computed: {
    listMaxHeight: {
      get() { return window.innerHeight - 385; },
      set() { } // 空 setter 避免警告
    }
    // selectedMode: {
    //   get() {
    //     return localStorage.getItem(userKeys.key_user_settings_image_mode) ? this.selectedMode : "business"
    //   },
    //   set(value) {
    //     localStorage.setItem(userKeys.key_user_settings_image_mode, value)
    //   }
    // },
  },
  //监控data中数据变化
  watch: {
    selectedItem(newValue) {
      // if (newValue != localStorage.getItem(userKeys.key_user_settings_image_style_index) || 0) {
      //   this.showSaveBtn = true
      // } else {
      //   this.showSaveBtn = false
      // }
      // for (let index = 0; index < this.imageStyles.length; index++) {
      //   this.imageStyles[index].selected = index == newValue ? true : false
      // }
      this.selectedImageStyleName = this.imageStyles.length > 0 ? this.imageStyles[newValue].text : localStorage.getItem(userKeys.key_user_settings_image_style)
      this.syncSaveBtnState()
    }
  },
  methods: {
    // getServiceAvatar() {
    //   return getServiceWindowAvatar(this.propsBot.CoverId);
    // },
    handleSwitchChange(status) {
      localStorage.setItem(userKeys.key_user_settings_swirecoke_template, status)
    },
    goback() {
      window.history.back()
    },
    syncLatestState() {
      this.selectedItem = localStorage.getItem(userKeys.key_user_settings_image_style_index) || 0
      this.selectedMode = localStorage.getItem(userKeys.key_user_settings_image_mode) || ImageGenerateMode.BUSINESS
      this.selecteStyledMode = localStorage.getItem(userKeys.key_user_settings_image_style_mode) || ImageStyleMode.AI
    },
    subscriptions() {
      this.$router.push("/subscriptions")
    },
    settings() {
      this.syncLatestState()

      for (let index = 0; index < this.imageStyles.length; index++) {
        this.imageStyles[index].selected = index == this.selectedItem ? true : false
      }
      this.syncSaveBtnState()
      this.dialog = true
    },
    saveSettings() {
      if (this.selecteStyledMode === ImageStyleMode.HUMAN && (this.selectedImageStyleName == "" || this.selectedImageStyleName == null)) {
        this.$message.warning(i18n.t("ppt_add_in_main.txt_remind_pls_select_image_style"))
        return
      }
      localStorage.setItem(userKeys.key_user_settings_image_mode, this.selectedMode)
      localStorage.setItem(userKeys.key_user_settings_image_style_mode, this.selecteStyledMode)
      localStorage.setItem(userKeys.key_user_settings_image_style_index, this.selectedItem)
      localStorage.setItem(userKeys.key_user_settings_image_style, this.selectedImageStyleName)
      this.dialog = false
    },
    selectBussiness() {
      this.selectedMode = ImageGenerateMode.BUSINESS
      this.switchHumanSelectIndexWhenChangeImgMode()
      this.syncSaveBtnState()
    },
    selectFree() {
      this.selectedMode = ImageGenerateMode.FREE
      this.switchHumanSelectIndexWhenChangeImgMode()
      this.syncSaveBtnState()
    },
    selectImageStyleAIMode() {
      this.selecteStyledMode = ImageStyleMode.AI
      this.switchHumanSelectIndexWhenChangeImgMode()
      this.syncSaveBtnState()
    },
    selectImageStyleHumanMode() {
      this.selecteStyledMode = ImageStyleMode.HUMAN
      this.switchHumanSelectIndexWhenChangeImgMode()
      this.syncSaveBtnState()
    },
    switchHumanSelectIndexWhenChangeImgMode(){
      this.getImageStyle()
      if (this.selecteStyledMode == ImageStyleMode.HUMAN) {
        if(this.selectedItem >= this.imageStyles.length) {
          this.selectedItem = 0
        }
        this.selectedImageStyleName = this.imageStyles[this.selectedItem].text
      }
    },
    syncSaveBtnState() {
      this.showSaveBtn = !localStorage.getItem(userKeys.key_user_settings_image_mode) ||
        this.selectedMode !== localStorage.getItem(userKeys.key_user_settings_image_mode) ||
        this.selecteStyledMode != localStorage.getItem(userKeys.key_user_settings_image_style_mode) ||
        this.selectedItem != localStorage.getItem(userKeys.key_user_settings_image_style_index)
    },
    previewArtList() {
      this.isArtListVisible = !this.isArtListVisible
      this.listMaxHeight = window.innerHeight - 385;
      window.addEventListener('resize', this.updateListMaxHeight);
    },
    previewModeList() {
      this.isModeVisible = !this.isModeVisible
    },
    clickCloseSettings() {
      this.dialog = false
    },
    clickLogoutBtn() {
      const now = new Date().getTime()
      if (this.clickLogOutBtnTime === null) {
        this.clickLogOutBtnTime = now
        this.$message.warning(i18n.t("ppt_add_in_main.logout_time_remind"))
      } else {
        const timeDifference = now - this.clickLogOutBtnTime
        if (timeDifference <= 5000) {
          this.clickLogOutBtnTime = null
          this.logout()
        } else {
          this.$message.warning(i18n.t("ppt_add_in_main.logout_time_remind"))
          this.clickLogOutBtnTime = now
        }
      }
    },
    logout() {
      localStorage.clear()
      resetAllModulesState()
      this.$router.replace("/login")
    },
    createWholeTemplateSlides() {
      publish(actionMenuPubIds.pubId_Action_Menu_Whole_Template_PPT, "")
    },
    createWholeSlides() {
      publish(actionMenuPubIds.pubId_Action_Menu_Whole_PPT, "")
    },
    createOnePageSlides() {
      publish(actionMenuPubIds.pubId_Action_Menu_One_Page_PPT, "")
    },
    showSlideOutline() {
      publish(actionMenuPubIds.pubId_Action_Menu_Outline_PPT, "")
    },
    createPPTfromFile() {
      publish(actionMenuPubIds.pubId_Action_Menu_PPT_From_File, "")
    },
    getImageStyle() {
      this.updateImageStyleLanguageData()
      const matchedMode = this.ImageStyle.find(item => item.Mode === this.selectedMode);
      this.imageStyles = matchedMode ? matchedMode.styles : []
      return this.imageStyles;
    },
    reorderArrayByIndex() {
      let index = localStorage.getItem(userKeys.key_user_settings_image_style_index) || 0
      const target = this.imageStyles[index]; // 获取目标元素  
      const rest = this.imageStyles.filter((_, i) => i !== index); // 过滤掉目标元素  
      this.imageStyles = [target, ...rest]; // 将目标元素放在第一个位置，其他元素顺序不变   
    },
    updateListMaxHeight() {
      this.$forceUpdate();
    },
    updateImageStyleLanguageData() {
      i18n.locale = wdConfigData.localLanguage
      if (i18n.locale == "zhHans") {
        aiMenusZh.resetState()
        this.ImageStyle = aiMenusZh.state.ImageStyle
      } else {
        aiMenusEn.resetState()
        this.ImageStyle = aiMenusEn.state.ImageStyle
      }
    }
  },
  beforeDestroy() {
    window.addEventListener('resize', this.updateListMaxHeight);
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    i18n.locale = wdConfigData.localLanguage
    this.items = [
      { title: i18n.t("welcomeMessageCard.action_create_whole_slides") },
      { title: i18n.t("welcomeMessageCard.action_create_slide_outline") },
      { title: i18n.t("welcomeMessageCard.action_create_one_page_slide") },
      { title: i18n.t("welcomeMessageCard.action_create_ppt_from_file") },
      { title: i18n.t("welcomeMessageCard.action_create_whole_template_slides") },
    ]
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    this.updateImageStyleLanguageData()
    // this.reorderArrayByIndex()
    // this.selectedItem = localStorage.getItem(userKeys.key_user_settings_image_style_index) || 0
    window.addEventListener('resize', this.updateListMaxHeight);
    let enterpriseDomainName = ''
    if (localStorage.getItem(userKeys.key_login_AccountName)) {
      const match = localStorage.getItem(userKeys.key_login_AccountName).match(/@([^@]+)\.com/)
      enterpriseDomainName = match ? match[1] : ''
    }
    if (enterpriseDomainName.includes('botest') || enterpriseDomainName.includes('copilot')) {
      this.showSwireCokeBtn = true
    } else {
      this.showSwireCokeBtn = false
    }
  },
  destroyed() { }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss" scoped>
.scroll-area {
  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  /* Firefox */
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;

  /* Chrome/Edge: 滚动条不占空间 */
  padding-right: 10px;
  /* 给出滚动条预留的空间，避免抖动 */
}

/* Webkit 浏览器 */
::v-deep(.scroll-area::-webkit-scrollbar) {
  width: 6px;
  height: 0px;
  /* 不显示横向 */
}

::v-deep(.scroll-area::-webkit-scrollbar-thumb) {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.imageDialogCard {
  width: 100%;
  // margin-top: 10px;
  display: inline-block;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  //border: 2px solid rgba(0, 0, 0, 0.1);  
  // border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
  // padding: 0px 6px 5px 6px;
}

.imag-select-header-area {
  width: 100%;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: rgb(248, 249, 250);
  z-index: 10;
  font-size: 14px;
  font-weight: bold;
}

.v-list {
  overflow: hidden;
  /* Hide the scrollbar */
  max-height: 500px;
}

.v-list:hover {
  overflow: auto;
  /* Show the scrollbar on hover */
}

.style-header {
  background-color: white;
  padding: 5px 10px 8px 10px;
  // border-radius: 8px;
  // box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  // margin-bottom: 10px;
}

.art-title-mode {
  font-size: 11px;
  color: #666;
}

.mode-select-options {
  display: flex;
  gap: 10px;
  margin-bottom: 6px;
}

.mode-select-option {
  flex: 1;
  padding: 5px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.05s ease;
  max-width: 50%;
}

.mode-select-option:hover {
  border-color: #90caf9;
}

.mode-select-option.active {
  border: 1px solid #2b579a;
  background-color: #e3f2fd;
}

.mode-select-option h5 {
  font-size: 13px;
  margin: 0 0 5px 0;
  color: #333;
}

.mode-select-option p {
  margin: 0;
  color: #666;
  font-size: 13px;
}

.select-mode-remind-text {
  font-size: 13px;
  margin: 0px 0 10px 0;
  color: black;
  // color: #666;
  // font-style: italic;
}

.img-container-mode {
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  min-height: 100px;
  /* 设置最小高度 */
}

.img-container-mode img {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.subtitle-text {
  font-size: 12px;
  margin: 5px 0 2px 0;
  color: black;
  font-weight: bold;
  // color: #666;
  // font-style: italic;
}

.selected-img-style {
  display: flex;
  margin-top: 18px;
  font-size: 12px;
  color: #666;
}

.art-title-style {
  margin-top: 15px;
  font-size: 11px;
  color: #666;
}

.custom-list-item {
  max-width: 100%;
  height: 110px !important;
  min-height: 40px !important;
  /* 控制最小高度 */
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.img-container {
  align-self: center;
  align-items: center;
  // margin-right: 12px;
}

.img-container img {
  max-width: 100%;
  width: 80px;
  height: 80px;
  object-fit: cover;
}
</style>
